import { AddPaymentMethod } from '@/components/addPaymentMethod/AddPaymentMethod';
import { PumpModal } from '@/components/addPump/PumpModal';
import { ChangeBusinessAddress } from '@/components/changeBusinessAddress/ChangeBusinessAddress';
import { ChangeEmail } from '@/components/changeEmail/ChangeEmail';
import { ChangePassword } from '@/components/changePassword/ChangePassword';
import { ConfirmCancel } from '@/components/confirmCancel/ConfirmCancel';
import { CreateStation } from '@/components/createStation/CreateStation';
import { FirstRunSuccess } from '@/components/firstRunWizard/FirstRunSuccess';
import { FirstRunWelcome } from '@/components/firstRunWizard/FirstRunWelcome';
import { EditMember } from '@/components/memberActions/editMember/EditMember';
import { InviteMember } from '@/components/memberActions/inviteMember/InviteMember';
import { MemberDetails } from '@/components/memberActions/memberDetails/MemberDetails';
import { ReactivateMember } from '@/components/memberActions/ReactivateMember';
import { RemoveMember } from '@/components/memberActions/RemoveMember';
import { SuspendMember } from '@/components/memberActions/SuspendMember';
import { TransferOwnership } from '@/components/memberActions/TransferOwnership';
import { CreateCatalogItem } from '@/components/createCatalogItem/CreateCatalogItem';
import { UploadCatalog } from '@/components/uploadCatalog/UploadCatalog';
import { UploadImage } from '@/components/uploadImage/UploadImage';

export const COMPONENTS = {
  'cancel.confirm': ConfirmCancel,
  'firstRun.welcome': FirstRunWelcome,
  'firstRun.success': FirstRunSuccess,
  'stations.create': CreateStation,
  'pump.create': PumpModal,
  'pump.add': PumpModal,
  'wallet.addPaymentMethod': AddPaymentMethod,
  'image.upload': UploadImage,
  'productCatalog.create': CreateCatalogItem,
  'productCatalog.upload': UploadCatalog,
  'settings.changeEmail': ChangeEmail,
  'settings.changeBusinessAddress': ChangeBusinessAddress,
  'settings.changePassword': ChangePassword,
  'members.invite': InviteMember,
  'members.edit': EditMember,
  'members.details': MemberDetails,
  'members.suspend': SuspendMember,
  'members.reactivate': ReactivateMember,
  'members.remove': RemoveMember,
  'members.transferOwnership': TransferOwnership,
};
